const fr = {
  profile: {
    title: 'Profil',
    email: 'Email',
    pseudo: 'Pseudo',
    language: 'Langue',
    password: 'Mot de passe',
    editPseudo: 'Modifier le pseudo',
    editThumbnail: 'Modifier la photo',
    updatePassword: 'Changer le mot de passe',
    editEmail: 'Changer l\'email',
    editLanguage: 'Changer la langue',
    pseudoMandatory: 'Choisissez un nom d\'affichage. C\'est ainsi que les autres utilisateurs vous verront.',
    saveName: 'Enregistrer le nom',
    savePhoto: 'Enregistrer la photo',
    savePassword: 'Mettre \u00e0 jour le mot de passe',
    saveLanguage: 'Enregistrer la langue',
    saveEmail: 'Mettre \u00e0 jour l\'email',
    nameUpdated: 'Nom mis \u00e0 jour avec succ\u00e8s',
    passwordUpdated: 'Mot de passe mis \u00e0 jour avec succ\u00e8s',
    languageUpdated: 'Langue mise \u00e0 jour avec succ\u00e8s',
    updateEmail: 'Changer l\'email',
    verificationEmail: 'Email de v\u00e9rification',
    verificationEmailSent: 'Un email de v\u00e9rification a \u00e9t\u00e9 envoy\u00e9 \u00e0 vos',
    newAndOld: 'nouvelles et anciennes',
    emailAddresses: 'adresses email. Veuillez',
    clickBothLinks: 'cliquer sur les deux liens.',
    ok: 'Ok',
    basic: 'Basique',
    upgradePlan: 'Am\u00e9liorer le plan',
    seePayments: 'Voir les paiements',
    cancelSubscription: 'Annuler l\'abonnement',
    goTo: 'Aller \u00e0',
    fullNamePlaceholder: 'Nom complet',
    emailPlaceholder: 'Email',
    uploadImage: 'T\u00e9l\u00e9charger une image',
    sharingNotAvailable: 'Les fonctionnalit\u00e9s de partage ne sont pas disponibles avec le plan gratuit. Passez au plan Pro ou Enterprise pour y acc\u00e9der.',
    orgExists: 'Une organisation existe d\u00e9j\u00e0 pour votre domaine email.',
  },
  common: {
    edit: 'Modifier',
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    delete: 'Supprimer',
    add: 'Ajouter',
    search: 'Rechercher',
    loading: 'Chargement...',
    noResults: 'Aucun r\u00e9sultat',
    confirm: 'Confirmer',
    back: 'Retour',
    select: 'S\u00e9lectionner',
    send: 'Envoyer',
    update: 'Mettre \u00e0 jour',
    rename: 'Renommer',
    remove: 'Retirer',
    ok: 'Ok',
    create: 'Cr\u00e9er',
    convert: 'Convertir',
    seeMore: 'Voir plus',
    seeLess: 'Voir moins',
    me: 'Moi',
    owner: 'Propri\u00e9taire',
    invited: 'Invit\u00e9',
    contributor: 'Contributeur',
    viewer: 'Lecteur',
    requested: 'Demand\u00e9',
    revokeAccess: 'R\u00e9voquer l\'acc\u00e8s',
    leave: 'Quitter',
    present: 'Pr\u00e9senter',
    namePlaceholder: 'Nom',
    linkCopied: 'Lien copi\u00e9',
    modified: 'Modifi\u00e9',
    approve: 'Approuver',
    decline: 'Refuser',
    error: 'Erreur',
    success: 'Succès',
  },
  auth: {
    signIn: 'Se connecter',
    signUp: 'S\'inscrire',
    signOut: 'Se d\u00e9connecter',
    email: 'Email',
    password: 'Mot de passe',
    forgotPassword: 'Mot de passe oubli\u00e9 ?',
    resetPassword: 'R\u00e9initialiser le mot de passe',
    updatePassword: 'Changer le mot de passe',
    signInWithGoogle: 'Se connecter avec Google',
    signUpWithGoogle: 'S\'inscrire avec Google',
    newHereSignUp: 'Nouveau ? Inscrivez-vous',
    goBackToSignIn: 'Retour \u00e0 la connexion',
    goBackSignIn: 'Retour \u00e0 la connexion',
    invalidEmail: 'adresse email invalide',
    passwordMinLength: 'Le mot de passe doit contenir au moins 6 caract\u00e8res',
    confirmPassword: 'Confirmer le mot de passe',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    createAccount: 'Cr\u00e9er un compte',
    termsText: 'En cliquant sur "Cr\u00e9er un compte" ou "S\'inscrire avec Google", vous acceptez les Conditions d\'Utilisation et la Politique de Confidentialit\u00e9 de Bibliona. Nous utilisons des cookies pour am\u00e9liorer votre exp\u00e9rience sur notre site.',
    emailConfirmed: 'Email confirm\u00e9 avec succ\u00e8s !',
    resetPasswordDesc: 'Nous vous enverrons un lien pour r\u00e9initialiser votre mot de passe.',
    linkSentTo: 'Un lien a \u00e9t\u00e9 envoy\u00e9 \u00e0',
    signUpDesc: 'Consultez votre bo\u00eete mail pour confirmer votre adresse.',
    newPassword: 'Nouveau mot de passe',
    needSignInBeforeUpgrade: 'Connectez-vous pour am\u00e9liorer votre plan.',
    termsOfUse: 'Conditions d\'utilisation',
    privacyPolicy: 'Politique de confidentialit\u00e9',
    info: 'Info',
    optimizedForLargerScreen: 'L\'exp\u00e9rience est optimis\u00e9e pour les \u00e9crans plus grands.',
    passwordConfirmationMinLength: 'La confirmation du mot de passe doit contenir au moins 6 caract\u00e8res',
  },
  home: {
    welcome: 'Bienvenue !',
    welcomeDesc: 'Nouveau sur Bibliona ? Regardez cette courte vid\u00e9o pour bien d\u00e9marrer.',
    title: 'Accueil',
    personas: 'Personas',
    products: 'Produits',
    sharedExperiences: 'Exp\u00e9riences partag\u00e9es',
    createPersona: 'Cr\u00e9er un persona',
    createProduct: 'Cr\u00e9er un produit',
    createSharedExperience: 'Cr\u00e9er une exp\u00e9rience partag\u00e9e',
    noPersonas: 'Aucun persona pour le moment. Cr\u00e9ez le premier !',
    noProducts: 'Aucun produit pour le moment. Cr\u00e9ez le premier !',
    noSharedExperiences: 'Aucune exp\u00e9rience partag\u00e9e pour le moment.',
  },
  nav: {
    home: 'Accueil',
    personas: 'Personas',
    products: 'Produits',
    sharedExperiences: 'Exp\u00e9riences partag\u00e9es',
    hideMenu: 'Masquer le menu',
    openMenu: 'Ouvrir le menu',
    profile: 'Profil',
    signOut: 'Se d\u00e9connecter',
    giveFeedback: 'Partager un avis',
    support: 'Support',
    termsOfUse: 'Conditions d\'utilisation',
    privacyPolicy: 'Politique de confidentialit\u00e9',
  },
  search: {
    placeholder: 'Rechercher dans Bibliona\u2026',
    all: 'Tout',
    persona: 'Persona',
    product: 'Produit',
    experienceGroup: 'Exp\u00e9rience/Groupe',
    insight: 'Insight',
    sharedExperience: 'Exp\u00e9rience partag\u00e9e',
    noResultFound: 'Aucun r\u00e9sultat trouv\u00e9',
    experience: 'Exp\u00e9rience',
  },
  persona: {
    title: 'Persona',
    experiences: 'Exp\u00e9riences',
    products: 'Produits',
    sharedExperiences: 'Exp\u00e9riences partag\u00e9es',
    members: 'Membres',
    noExperiences: 'Aucune exp\u00e9rience pour le moment. Commencez par en ajouter une.',
    noProducts: 'Aucun produit pour le moment.',
    noSharedExperiences: 'Aucune exp\u00e9rience partag\u00e9e pour le moment.',
    addExperience: 'Ajouter une exp\u00e9rience',
    addProduct: 'Ajouter un produit',
    addSharedExperience: 'Ajouter une exp\u00e9rience partag\u00e9e',
    newSharedExperience: 'Nouvelle exp\u00e9rience partag\u00e9e',
    selectSharedExperience: 'S\u00e9lectionner une exp\u00e9rience partag\u00e9e',
    deletePersona: 'Supprimer le persona',
    editName: 'Modifier le nom',
    removeFromPersona: 'Retirer du persona',
    createNewSharedExperience: '+ Cr\u00e9er une nouvelle exp\u00e9rience partag\u00e9e',
    pleaseSelectSharedExperience: 'Veuillez s\u00e9lectionner une exp\u00e9rience partag\u00e9e',
    sharedExperiencesName: 'Nom de l\'exp\u00e9rience partag\u00e9e',
    enterSharedExperiencesName: 'Entrez le nom de l\'exp\u00e9rience partag\u00e9e',
    failedToAdd: '\u00c9chec de l\'ajout de l\'exp\u00e9rience partag\u00e9e',
    failedToCreate: '\u00c9chec de la cr\u00e9ation de l\'exp\u00e9rience partag\u00e9e',
    newPersona: 'Nouveau Persona',
    editPersona: 'Modifier le Persona',
    confirmDeletePersona: '\u00cates-vous s\u00fbr de vouloir supprimer ce persona ?',
    addValueProposition: 'Ajouter une proposition de valeur',
    addProductTypes: 'Ajouter des types de produit',
    addMainFeatures: 'Ajouter des fonctionnalit\u00e9s principales',
    addUsefulLinks: 'Ajouter des liens utiles',
    addPersonaToProduct: 'Ajouter un persona au produit',
    removeProduct: 'Retirer le produit',
    confirmRemoveProduct: '\u00cates-vous s\u00fbr de vouloir retirer ce produit du persona ?',
    removePersona: 'Retirer le persona',
    confirmRemovePersona: '\u00cates-vous s\u00fbr de vouloir retirer ce persona ?',
    age: '\u00c2ge',
    job: 'Emploi',
    education: '\u00c9ducation',
    familyStatus: 'Situation familiale',
    interests: 'Centres d\'int\u00e9r\u00eat',
    bioPlaceholder: 'Bio\u2026',
    quotePlaceholder: 'Citation\u2026',
    selectProduct: 'S\u00e9lectionner un produit',
    addSharedExperiences: 'Ajouter des exp\u00e9riences partag\u00e9es',
    newExperienceGroup: 'Nouveau groupe d\'exp\u00e9riences',
  },
  product: {
    title: 'Produit',
    experiences: 'Exp\u00e9riences',
    personas: 'Personas',
    sharedExperiences: 'Exp\u00e9riences partag\u00e9es',
    members: 'Membres',
    noExperiences: 'Aucune exp\u00e9rience pour le moment. Commencez par en ajouter une.',
    noPersonas: 'Aucun persona pour le moment.',
    noSharedExperiences: 'Aucune exp\u00e9rience partag\u00e9e pour le moment.',
    addExperience: 'Ajouter une exp\u00e9rience',
    addPersona: 'Ajouter un persona',
    addSharedExperience: 'Ajouter une exp\u00e9rience partag\u00e9e',
    newSharedExperience: 'Nouvelle exp\u00e9rience partag\u00e9e',
    selectSharedExperience: 'S\u00e9lectionner une exp\u00e9rience partag\u00e9e',
    deleteProduct: 'Supprimer le produit',
    editName: 'Modifier le nom',
    removeFromProduct: 'Retirer du produit',
    addProductToSharedExperience: 'Ajouter un produit \u00e0 l\'exp\u00e9rience partag\u00e9e',
    newProduct: 'Nouveau Produit',
    confirmDeleteProduct: '\u00cates-vous s\u00fbr de vouloir supprimer ce produit ?',
    addValueProposition: 'Ajouter une proposition de valeur',
    addProductTypes: 'Ajouter des types de produit',
    addMainFeatures: 'Ajouter des fonctionnalit\u00e9s principales',
    addSharedExperiences: 'Ajouter des exp\u00e9riences partag\u00e9es',
    addUsefulLinks: 'Ajouter des liens utiles',
    editLogo: 'Modifier le logo',
    uploadLogo: 'T\u00e9l\u00e9charger un logo',
    uploadLogoWithText: 'T\u00e9l\u00e9charger un logo avec texte',
    types: 'Types',
    valuePropositionPlaceholder: 'Objectif utilisateur\u2026 Douleur\u2026 Gain',
    featurePlaceholder: 'Fonctionnalit\u00e9\u2026',
    refinePlaceholder: 'Affiner\u2026',
    selectPersona: 'S\u00e9lectionner un persona',
    selectProduct: 'S\u00e9lectionner un produit',
    removePersona: 'Retirer le persona',
    confirmRemovePersona: '\u00cates-vous s\u00fbr de vouloir retirer ce persona du produit ?',
    newExperienceGroup: 'Nouveau groupe d\'exp\u00e9riences',
    descriptionPlaceholder: 'Description\u2026',
  },
  sharedExperience: {
    title: 'Exp\u00e9rience partag\u00e9e',
    experiences: 'Exp\u00e9riences',
    personas: 'Personas',
    products: 'Produits',
    sharedExperiences: 'Exp\u00e9riences partag\u00e9es',
    members: 'Membres',
    noExperiences: 'Aucune exp\u00e9rience pour le moment. Commencez par en ajouter une.',
    noPersonas: 'Aucun persona pour le moment.',
    noProducts: 'Aucun produit pour le moment.',
    noSharedExperiences: 'Aucune exp\u00e9rience partag\u00e9e pour le moment.',
    addExperience: 'Ajouter une exp\u00e9rience',
    addSharedExperience: 'Ajouter une exp\u00e9rience partag\u00e9e',
    newSharedExperience: 'Nouvelle exp\u00e9rience partag\u00e9e',
    selectSharedExperience: 'S\u00e9lectionner une exp\u00e9rience partag\u00e9e',
    deleteSharedExperience: 'Supprimer l\'exp\u00e9rience partag\u00e9e',
    editName: 'Modifier le nom',
    addPersonaToSharedExperience: 'Ajouter un persona \u00e0 l\'exp\u00e9rience partag\u00e9e',
    removeFromSharedExperience: 'Retirer de l\'exp\u00e9rience partag\u00e9e',
    addSharedExperiences: 'Ajouter des exp\u00e9riences partag\u00e9es',
    newExperienceGroup: 'Nouveau groupe d\'exp\u00e9riences',
    selectProduct: 'S\u00e9lectionner un produit',
    selectPersona: 'S\u00e9lectionner un persona',
    removeProduct: 'Retirer le produit',
    removePersona: 'Retirer le persona',
    ungroupedExperiences: 'Exp\u00e9riences non group\u00e9es',
    noExperiencesYet: 'Aucune exp\u00e9rience pour le moment',
    noMembersFound: 'Aucun membre trouv\u00e9',
    requestToEdit: 'Demander la modification',
  },
  experience: {
    title: 'Exp\u00e9rience',
    addExperience: 'Ajouter une exp\u00e9rience',
    editExperience: 'Modifier l\'exp\u00e9rience',
    deleteExperience: 'Supprimer l\'exp\u00e9rience',
    noInsights: 'Aucun insight pour le moment.',
    untitled: 'Sans titre',
    prototype: 'Prototype',
    addPrototypeLink: 'Ajouter un lien prototype',
    editObjective: 'Modifier l\'objectif',
    editPrototype: 'Modifier le prototype',
    addPrototype: 'Ajouter un prototype',
    newExperience: 'Nouvelle exp\u00e9rience',
    createNewExperience: 'Cr\u00e9er une nouvelle exp\u00e9rience',
    goToExperience: 'Aller \u00e0 l\'exp\u00e9rience',
    selectExperience: 'S\u00e9lectionner une exp\u00e9rience',
    experiencePlaceholder: 'Action : Faire\u2026 Trouver\u2026 Chercher\u2026',
    prototypeLinkLabel: 'Lien prototype',
    openPrototype: 'Ouvrir le prototype',
    objective: 'Objectif',
    objectivePlaceholder: 'Objectif',
    leaveGroup: 'Quitter le groupe',
    selectSharedExperience: 'S\u00e9lectionner une exp\u00e9rience partag\u00e9e',
    addSharedExperiences: 'Ajouter des exp\u00e9riences partag\u00e9es',
    selectProduct: 'S\u00e9lectionner un produit',
    pleaseSelectProduct: 'Veuillez s\u00e9lectionner au moins un produit',
    pleaseSelectSharedExperience: 'Veuillez s\u00e9lectionner une exp\u00e9rience partag\u00e9e',
    involvedProducts: 'Produits concern\u00e9s',
  },
  group: {
    createGroup: 'Cr\u00e9er un groupe',
    editGroupName: 'Modifier le nom du groupe',
    editName: 'Modifier le nom',
    ungroup: 'D\u00e9grouper',
    moveToGroup: 'D\u00e9placer dans un groupe',
    moveGroupToAnotherGroup: 'D\u00e9placer le groupe dans un autre groupe',
    goToGroup: 'Aller au groupe',
    convertToSharedExperience: 'Convertir en exp\u00e9rience partag\u00e9e',
    convert: 'Convertir',
    convertConfirm: '\u00cates-vous s\u00fbr de vouloir convertir le groupe',
    convertCannotBeUndone: 'en exp\u00e9rience partag\u00e9e ? Cette action est irr\u00e9versible.',
    selectGroup: 'S\u00e9lectionner un groupe',
    pleaseSelectGroup: 'Veuillez s\u00e9lectionner un groupe',
    groupName: 'Nom du groupe',
    groupNamePlaceholder: 'Nom du groupe',
  },
  comment: {
    deleteComment: 'Supprimer le commentaire',
    confirmDeleteComment: '\u00cates-vous s\u00fbr de vouloir supprimer ce commentaire ?',
    editPlaceholder: 'Modifier le commentaire',
  },
  insight: {
    insights: 'Insights',
    insightType: 'Type d\'insight',
    insight: 'Insight',
    importance: 'Importance',
    highest: 'Tr\u00e8s haute',
    high: 'Haute',
    medium: 'Moyenne',
    low: 'Basse',
    lowest: 'Tr\u00e8s basse',
    improvementFeedback: 'Retour d\'am\u00e9lioration',
    positiveFeedback: 'Retour positif',
    negativeFeedback: 'Retour n\u00e9gatif',
    behavior: 'Comportement',
    motivation: 'Motivation',
    addImprovementFeedback: 'Ajouter un retour d\'am\u00e9lioration',
    addPositiveFeedback: 'Ajouter un retour positif',
    addNegativeFeedback: 'Ajouter un retour n\u00e9gatif',
    addBehavior: 'Ajouter un comportement',
    addMotivation: 'Ajouter une motivation',
    current: 'Actuels',
    outdated: 'Obsol\u00e8tes',
    noInsightSoFar: 'Aucun insight pour le moment',
    noOutdatedInsight: 'Aucun insight obsol\u00e8te',
    setAsOutdated: 'Marquer comme obsol\u00e8te',
    setAsCurrent: 'Marquer comme actuel',
    insightSetAsOutdated: 'Insight marqu\u00e9 comme obsol\u00e8te',
    insightSetAsCurrent: 'Insight restaur\u00e9',
    insightDeleted: 'Insight supprim\u00e9',
    moveToStart: 'D\u00e9placer en d\u00e9but de liste',
    moveToEnd: 'D\u00e9placer en fin de liste',
    addImage: 'Ajouter une image',
    editImages: 'Modifier les images',
    addQuote: 'Ajouter une citation',
    editQuotes: 'Modifier les citations',
    moveToExperience: 'D\u00e9placer vers une exp\u00e9rience',
    confirmDeleteInsight: '\u00cates-vous s\u00fbr de vouloir supprimer cet insight ?',
    involvedPersona: 'Personas concern\u00e9s',
    involvedProducts: 'Produits concern\u00e9s',
    selectExperience: 'S\u00e9lectionner une exp\u00e9rience',
    noImageSoFar: 'Aucune image pour le moment',
    quotePlaceholder: 'Citation',
    fact: 'Fait',
    assumption: 'Hypoth\u00e8se',
    moreOptions: 'Plus d\'options',
    appliesToAllPersona: 'S\'applique \u00e0 tous les personas de cette exp\u00e9rience',
    appliesToAllProducts: 'S\'applique \u00e0 tous les produits de cette exp\u00e9rience',
    or: 'OU',
  },
  members: {
    members: 'Membres',
    generalAccess: 'Acc\u00e8s g\u00e9n\u00e9ral',
    editionRequested: 'Modification demand\u00e9e',
    editionRequestPending: 'Demande de modification en attente',
    requestEdit: 'Demander la modification',
    requestWillBeSent: 'Une demande sera envoy\u00e9e \u00e0',
    addPeoplePlaceholder: 'Ajouter des personnes par recherche ou email',
    invitedTooltip: 'Cet utilisateur sera ajout\u00e9 apr\u00e8s son inscription',
    subscriptionUpgraded: 'Votre abonnement a \u00e9t\u00e9 am\u00e9lior\u00e9',
    loadFailed: 'Échec du chargement des données des membres',
    editRequestSent: 'Demande d\'édition envoyée avec succès',
    editRequestFailed: 'Échec de l\'envoi de la demande d\'édition',
  },
  organisation: {
    inviteNewMember: 'Inviter un nouveau membre',
    invitationSent: 'Invitation envoy\u00e9e avec succ\u00e8s',
    invitationFailed: 'D\u00e9sol\u00e9, l\'invitation n\'a pas pu \u00eatre envoy\u00e9e.',
    howToAddMembers: 'Comment ajouter de nouveaux membres ?',
    howToAddMembersDesc: 'Les nouveaux utilisateurs devront se connecter avec un email correspondant \u00e0 l\'un des domaines ci-dessous. Ils seront ensuite automatiquement ajout\u00e9s \u00e0 votre organisation.',
    howToInviteMembers: 'Comment inviter de nouveaux membres ?',
    howToInviteMembersDesc: 'En cliquant sur "envoyer l\'email", un email d\'invitation sera envoy\u00e9 \u00e0 l\'adresse saisie. Le nouveau membre devra ensuite s\'inscrire et sera automatiquement ajout\u00e9 \u00e0 votre organisation.',
    domains: 'Domaines',
    domainPlaceholder: 'domaine',
    upcomingInvoice: 'Prochaine facture',
    invoiceTooltip: 'Inclut le prorata du mois pr\u00e9c\u00e9dent si de nouveaux utilisateurs ont \u00e9t\u00e9 ajout\u00e9s.',
    editLogo: 'Modifier le logo',
    upgradeToEnterprise: 'Passer au plan Enterprise',
  },
  feedback: {
    thankYou: 'Merci d\'avoir partag\u00e9 votre avis',
    feedbackType: 'Type de retour',
    description: 'Description',
  },
  payment: {
    payments: 'Paiements',
    success: 'Succ\u00e8s',
    fail: '\u00c9chec',
    seeInvoice: 'Voir la facture',
    anyProblem: 'Un probl\u00e8me ?',
    contactSupport: 'Contacter le support',
    subscriptionCanceled: 'Votre abonnement a \u00e9t\u00e9 annul\u00e9.',
    contactSupportQuestion: 'Pour toute question, contactez le support',
    thankYouSubscription: 'Merci pour votre abonnement !',
    paymentSuccessful: 'Votre paiement a \u00e9t\u00e9 effectu\u00e9 avec succ\u00e8s.',
    goHome: 'Retour \u00e0 l\'accueil',
  },
  notFound: {
    title: '404 - Page non trouv\u00e9e',
  },
  recents: {
    noRecents: 'Aucun \u00e9l\u00e9ment r\u00e9cent',
  },
  subscription: {
    plan: 'Plan',
    free: 'Gratuit',
    pro: 'Pro',
    enterprise: 'Enterprise',
    upgrade: 'Am\u00e9liorer',
    currentPlan: 'Plan actuel',
    perMonth: '/mois',
    perUserMonth: '/utilisateur/mois',
    managePlan: 'G\u00e9rer le plan',
    choosePlan: 'Choisissez un plan',
    basic: 'Basique',
    includes: 'Inclut : ',
    unlimitedProducts: 'Produits illimit\u00e9s',
    unlimitedPersonas: 'Personas illimit\u00e9s',
    unlimitedExperiences: 'Exp\u00e9riences illimit\u00e9es',
    sharingFeatures: 'Fonctionnalit\u00e9s de partage et collaboration',
    orgAlreadyExists: 'Une organisation avec votre domaine email existe d\u00e9j\u00e0',
    libraryAccess: 'Biblioth\u00e8que de Personas et Produits accessible \u00e0 tous les collaborateurs',
    commonBilling: 'Facturation commune',
    joinedOrganisation: 'Vous avez rejoint l\'organisation',
    join: 'Rejoindre',
    cancelSubscription: 'Annuler l\'abonnement',
    cancelConfirm: '\u00cates-vous s\u00fbr de vouloir annuler votre abonnement ? L\'annulation prend effet imm\u00e9diatement et vous perdrez l\'acc\u00e8s \u00e0 toutes les fonctionnalit\u00e9s premium.',
    typeCancelToConfirm: 'Veuillez taper "cancel subscription" pour confirmer.',
    subscriptionCanceled: 'Votre abonnement a \u00e9t\u00e9 annul\u00e9',
    approveEditionRequest: 'Approuver la demande de modification',
    declineEditionRequest: 'Refuser la demande de modification',
  },
  maintenance: {
    message: 'Nous effectuons actuellement une maintenance. Le service sera de retour sous peu. Merci de votre patience.',
  },
  languages: {
    en: 'Anglais',
    fr: 'Fran\u00e7ais',
  },
};

export default fr;
